import { useNavigate, useSearchParams } from 'react-router-dom'
import { NavBack } from '../components/nav-back'

export const ConfirmEmailView = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const defaultEmail = searchParams.get('addr')

  return (
    <div className='main_content experience_content experience_content-alt'>
      <NavBack />
      <div>
        <h1 className='heading-styled'>Almost there! Check your e-mail...</h1>
        <p>
          We've sent an email to <em>{defaultEmail}</em>. Follow the verification link in the email
          to complete the sign-up process.
        </p>
        <span className='span-a' onClick={() => navigate('/', { viewTransition: true })}>
          Back to home page
        </span>
      </div>
    </div>
  )
}
